export const APP_FROMNAME = 'APP_FROMNAME'
export const APP_TONAME = 'APP_TONAME'
export const APP_TITLE = 'APP_TITLE'
export const APP_DIRECTION = 'APP_DIRECTION'
export const APP_LOADING = 'APP_LOADING'
export const APP_LOCATION_LOADING = 'APP_LOCATION_LOADING'


// WEBPACK FOOTER //
// ./src/store/modules/common/constant.js